import { RootState } from '../../../../rootReducer';

export const withdrawalReportSelector = (state: RootState) => state.eventsLogModuleReducer.WithdrawalReportReducer;
